module.exports = __webpack_public_path__ + "assets/img/00031.86ec7d5e.png";